import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Card, Divider, List } from 'semantic-ui-react';

import { formatCurrency } from '../../../../../helpers/utils';
import { InvoiceItem } from '../../../../Shared/InvoiceItem';

import './DetailsWidget.scss';

const DetailsWidget = ({ invoiceSummary }) => {
  const { t } = useTranslation();

  return (
    <Card fluid className={'details-widget'}>
      <Card.Content className={'details-widget-header'}>
        <Card.Header data-testid="invoice-detail-title" textAlign="center">
          {t('billing.invoiceDetail.title')}
        </Card.Header>
      </Card.Content>
      <Card.Content>
        <List>
          {invoiceSummary &&
            invoiceSummary.items.map((item, index) => (
              <InvoiceItem key={`invoiceItemSummary${index}`} item={item} index={index} />
            ))}
          <Divider />
          <List.Item>
            <List.Content>
              <List.Header>
                <div data-testid="invoice-detail-total-label">{t('billing.invoiceCreation.summary.totalLabel')}</div>
                <div data-testid="invoice-detail-total-value">
                  {invoiceSummary && formatCurrency(invoiceSummary.total)}
                </div>
              </List.Header>
            </List.Content>
          </List.Item>
        </List>
      </Card.Content>
    </Card>
  );
};

DetailsWidget.propTypes = {
  invoiceSummary: PropTypes.object,
};

export default DetailsWidget;
